import * as React from 'react';
import { ModalView } from '@cian/ui-kit/prev';
import { Button } from '@cian/button-component';
import * as styles from './index.css';

const failureIcon = require('./failure.svg') as string;

export interface IDealRentFailureModalProps {
  isOpen: boolean;
  closeModal(): void;
}

export const DealRentFailureModal = ({ isOpen, closeModal }: IDealRentFailureModalProps) => {
  return (
    <ModalView onClose={closeModal} custom={{ open: isOpen, mediaType: 'desktop' }}>
      <div className={styles['container']}>
        <img src={failureIcon} />
        <h1 className={styles['title']}>Вы уже отправляли анкету по этому объявлению</h1>
        <div className={styles['text']}>Вам придёт СМС с ответом собственника</div>
        <Button onClick={closeModal}>Хорошо</Button>
      </div>
    </ModalView>
  );
};
